module.exports = __webpack_public_path__ + "img/features04-05.6f3cb54.png";